// export class Account {
//   public Id: string;
//   public agency_id: string;
//   public account_id: string;
//   public name: string;
//   public slug: string;
//
//   // constructor(data: any) {
//   //   this.Id = data.Id;
//   //   this.agency_id = data.agency_id;
//   //   this.account_id = data.account_id;
//   //   this.name = data.name;
//   //   this.slug = data.slug;
//   // }
//
//   // account: Account[] = [
//   //   new Account('1', '1', '1', '1', '1'),
//   // ];
//
//   constructor(Id: string, agency_id: string, account_id: string, name: string, slug: string) {
//     this.Id = Id;
//     this.agency_id = agency_id;
//     this.account_id = account_id;
//     this.name = name;
//     this.slug = slug;
//   }
// }

//better to use this class

//used for get
export interface  AccountInterfaceData {
  Id: string,
  agency_id: string,
  account_id: string,
  name: string,
  description: string,
  slug: string,
  time_zone: string
}

export interface  AccountInterfacePostData {
  agency_id: string,
  name: string,
  description: string,
  slug: string,
  time_zone: string
}

export class Account {
  constructor(public Id: string,
              public agency_id: string,
              public account_id: string,
              public name: string,
              public description: string,
              public slug: string,
              public time_zone: string) {}
}

// const acc:Account = new Account(data[_i]['Id'],
//   data[_i]['agency_id'],
//   data[_i]['account_id'],
//   data[_i]['name'],
//   data[_i]['description'],
//   data[_i]['slug'])
